import React from "react";

const HerbCalc = () => {
  return <div>Calculation in progress...</div>;
};

export default HerbCalc;
